import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
import LoanDetailContext from '../../context/loanDetailContext';
import query from '../../query';
import { useHistory } from 'react-router-dom';
import { Row } from 'reactstrap';
import { Table, Thead, Tbody, Th, Tr, Td } from 'react-super-responsive-table';
import NoDataFound from '../../components/noDataFound/noDataFound';
import Loader from '../../components/loader/Loader';

const TABLE_HEADERS = [
  { value: 'Date' },
  { value: 'Subject' },
  { value: 'Status' },
  { value: '' },
];

const Complaints = () => {
  const loanDetail = useContext(LoanDetailContext);
  const loanId = loanDetail.loan_id;
  const history = useHistory();

  const { loading, data } = useQuery(query.getComplaints, {
      variables: { loanId },
      fetchPolicy: 'network-only'
  });

  const complaints = data?.complaints || [];
  if (loading) return <Loader />;

  const openComplaint = id => {
    history.push(`/Complaints/${id}`);
  };

  return (
    <Row className="centered">
      <div className="col-md-12 col-lg-12 col-12 my-4 pr-0 pl-0">
        <div className="d-block d-md-flex  align-items-center">
          <h3>
            <b>My Complaints</b>
          </h3>
          <button
            type="button"
            className='alert-button text-white ml-auto'
            onClick={() => history.push('/Complaints/new')}
          >
            { 'New Complaint' }
          </button>
        </div>
        <div className="mb-2">
          <div className="mt-3">
            <fieldset>
              <div className="table-responsive scrolly">
                {complaints.length > 0 ? (
                  <Table
                    className="payment-history-table table table-condensed py-0 py-lg-4 m-0 mt-lg-2"
                    id="toggleTable"
                  >
                    <Thead>
                      <Tr>
                        {TABLE_HEADERS.map((header, index) => (
                          <Th key={index}>
                            {header.value}
                          </Th>
                        ))}
                      </Tr>
                    </Thead>
                    <Tbody className="panel">
                      {complaints.map((complaint, index) => (
                        <Tr
                          key={complaint.id}
                          className={index % 2 === 0 ? 'odd-row' : 'even-row'}
                        >
                          <Td>
                            {complaint.createdAt}
                          </Td>
                          <Td>
                            {complaint.subject}
                          </Td>
                          <Td>{complaint.status}</Td>
                          <Td className="card-delete-icon text-center">
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={() => openComplaint(complaint.id)}
                            >
                              <i className="fa fa-eye fa-lg" />
                            </button>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                ) : (
                  <NoDataFound />
                )}
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </Row>
  );
};

export default Complaints;
